import { FC } from 'react';

import { IcShareScreen24Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import styles from './SharedScreen.styles.m.css';

export const SharedScreen: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <IconView
        Icon={IcShareScreen24Icon}
        className={styles.icon}
        size={IconViewSizes.Medium}
      />
      {t('sharing_screen')}
    </div>
  );
};
